<template>
  <div class="p-2" slot="dialog-content">
    <div v-if="isImage" class="image-preview-container">
      <embed :src="url" frameborder="0" width="100%" height="auto" />
    </div>
    <div v-else-if="isPdf" class="pdf-preview-container">
      <iframe
        :src="url"
        frameborder="0"
        width="100%"
        height="100%"
      />
    </div>
    <div v-else-if="isOfficeDoc" class="doc-preview-container">
      <VueDocPreview :value="url" type="office" />
    </div>
  </div>
</template>
<script>
import VueDocPreview from "vue-doc-preview";

export default {
  name: "FilePreview",
  props: {
    url: String,
  },
  components: {
    VueDocPreview,
  },
  data() {
    return {
      displayPdf: false,
    };
  },
  created() {
    setTimeout(() => {
      this.displayPdf = true;
    }, 1000);
  },
  computed: {
    fileExtension() {
      try {
        return this.url.split(".").pop().toLowerCase();
      } catch (e) {
        return null;
      }
    },
    isPdf() {
      return this.fileExtension === "pdf";
    },
    isImage() {
      return ["png", "jpg", "jpeg"].includes(this.fileExtension);
    },
    isOfficeDoc() {
      return ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(
        this.fileExtension
      );
    },
    isIphone() {
      return this.getMobileOperatingSystem() === "iOS";
    },
  },
};
</script>

<style scoped>
.image-preview-container {
  height: calc(90vh - 2rem - 44px);
  overflow: auto;
}

.pdf-preview-container {
  height: calc(90vh - 2rem - 44px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/documents/FilePreview.vue